import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import RequestService from "@services/RequestService";
import axios from "axios";

export const callRequest = createAsyncThunk(
  "request/call",
  async ({name, phone, email, time}) => {
    try {
      await axios.post(`/guest/requests/call`, {
        name,
        phone,
        email,
        time,
      });
    } catch (err) {
      console.log(err);
    }
  },
);

export const helpRequest = createAsyncThunk(
  "request/help",
  async ({name, email, message}) => {
    try {
      await axios.post(`/guest/requests/assistance`, {
        name,
        email,
        description: message,
      });
    } catch (err) {
      console.log(err);
    }
  },
);

export const presentationRequest = createAsyncThunk(
  "request/presentation",
  async ({name, phone, email, message}) => {
    try {
      await axios.post(`/guest/requests/presentation`, {
        name,
        phone,
        email,
        message,
      });
    } catch (err) {
      console.log(err);
    }
  },
);

export const sendReport = createAsyncThunk(
  "request/report",
  async ({title, message}) => {
    try {
      const response = await RequestService.sendReport(title, message);

      return response.data;
    } catch (err) {
      throw new Error("Don't send report!", err);
    }
  },
);

export const sendUserFeedback = createAsyncThunk(
  "request/user-feedback",
  async ({steps}) => {
    try {
      const response = await RequestService.userFeedback(steps);

      return response.data;
    } catch (err) {
      throw new Error("Don't send user feedback!", err);
    }
  },
);

const initialState = {
  name: "",
  phone: "",
  email: "",
  time: "",
  message: "",
  data: "",
  reason: "",
  title: "",
  agree: false,
  errors: null,
  error: "",
  status: "",
};

const requestSlice = createSlice({
  name: "request",
  initialState,
  reducers: {
    setName(state, action) {
      state.name = action.payload;
    },
    setPhone(state, action) {
      state.phone = action.payload;
    },
    setEmail(state, action) {
      state.email = action.payload;
    },
    setTime(state, action) {
      state.time = action.payload;
    },
    setMessage(state, action) {
      state.message = action.payload;
    },
    setData(state, action) {
      state.data = action.payload;
    },
    setReason(state, action) {
      state.reason = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
    setAgree(state, action) {
      state.agree = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearForm(state) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      // Call request
      .addCase(callRequest.pending, (state) => {
        state.status = "loading";
        state.errors = null;
        state.error = "";
      })
      .addCase(callRequest.fulfilled, (state) => {
        state.name = "";
        state.phone = "";
        state.email = "";
        state.time = "";
        state.agree = false;
        state.status = "success";
        state.errors = null;
        state.error = "";
      })
      .addCase(callRequest.rejected, (state, action) => {
        state.errors = action.payload?.errors;
        state.error = action.payload?.message;
        state.status = "error";
      })

      // Help request
      .addCase(helpRequest.pending, (state) => {
        state.status = "loading";
        state.errors = null;
        state.error = "";
      })
      .addCase(helpRequest.fulfilled, (state) => {
        state.name = "";
        state.email = "";
        state.message = "";
        state.agree = false;
        state.errors = null;
        state.error = "";
        state.status = "success";
      })
      .addCase(helpRequest.rejected, (state, action) => {
        state.errors = action.payload?.errors;
        state.error = action.payload?.message;
        state.status = "error";
      })

      // Presentation request
      .addCase(presentationRequest.pending, (state) => {
        state.status = "loading";
        state.errors = null;
        state.error = "";
      })
      .addCase(presentationRequest.fulfilled, (state) => {
        state.name = "";
        state.phone = "";
        state.email = "";
        state.message = "";
        state.agree = false;
        state.status = "success";
        state.errors = null;
        state.error = "";
      })
      .addCase(presentationRequest.rejected, (state, action) => {
        state.errors = action.payload?.errors;
        state.error = action.payload?.message;
        state.status = "error";
      })

      // Send report
      .addCase(sendReport.pending, (state) => {
        state.status = "loading";
        state.errors = null;
        state.error = "";
      })
      .addCase(sendReport.fulfilled, (state) => {
        state.title = "";
        state.message = "";
        state.error = "";
        state.status = "success";
        state.errors = null;
      })
      .addCase(sendReport.rejected, (state, action) => {
        state.errors = action.payload?.errors;
        state.error = action.payload?.message;
        state.status = "error";
      })

      // Send user feedback
      .addCase(sendUserFeedback.pending, (state) => {
        state.status = "loading";
        state.errors = null;
        state.error = "";
      })
      .addCase(sendUserFeedback.fulfilled, (state) => {
        state.status = "success";
        state.errors = null;
        state.error = "";
      })
      .addCase(sendUserFeedback.rejected, (state, action) => {
        state.errors = action.payload?.errors;
        state.error = action.payload?.message;
        state.status = "error";
      });
  },
});

export const {
  setName,
  setPhone,
  setEmail,
  setTime,
  setMessage,
  setData,
  setReason,
  setTitle,
  setAgree,
  setErrors,
  setError,
  setStatus,
  clearForm,
} = requestSlice.actions;
export default requestSlice.reducer;
